var exports = {
  "$": "Button__DzITGA",
};

module.exports = exports;
